<template>
	<div
		:id="uploadDropBox"
		ref="file"
		:accept="acceptAttribute"
		:class="['dropBox', disableAtLimit]"
		type="file"
		name="uploadFile"
		@dragover="dragover"
		@dragleave="dragleave"
		@drop="uploadFile"
		@click="$refs.file.click"
	>
		<div class="cloudIcon" />
		<p>Drag and drop files here</p>
		<div :class="['docSelection', 'newButtonContainer', disableAtLimit,noFiles]">
			<div ref="addDocument" class="newButton" @click.stop="addDocumentOnClick">
				Add Document
			</div>
			<ul class="newButtonListing">
				<li class="newButtonListItem myDocsNewFolderListItem">
					<a href="" class="newButtonListItemLink fileUpload" @click.prevent.stop="$refs.file.click">Upload Document</a>
				</li>
				<li class="newButtonListItem">
					<a v-if="!isSignedIn" class="newButtonListItemLink addExisting" @click.stop="openSignInDialog">Add from LawDepot</a>
					<a v-if="isSignedIn" class="newButtonListItemLink addExisting" @click.stop="openShowExistingDialog">Add from LawDepot</a>
				</li>
			</ul>
		</div>
		
		<select-existing-document @addToNotarize="addDocuments" />
	</div>
	<input
		:id="uploadFileInputId"
		ref="file"
		:accept="acceptAttribute"
		class="fileUpload fileUploadInput"
		type="file"
		name="uploadFile"
		multiple
		@change="uploadFile"
		@click.stop
	>
</template>

<script>
import SelectExistingDocument from "./SelectExistingDocument.vue";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import {
	upload as vfsUpload,
	myDocuments,
	lawDepot,
} from "@ado/notarization-vue-common/src/API/vfs.api";
import { extension } from "../../helpers/file.js";
import { nanoid } from "nanoid";
import { isUserSignedIn } from "../../helpers/signin";
import UploadMessages from "./UploadMessages.js";
import { ItemTileFade } from "../../mixins/ItemTileFade";


document.onmouseup = closeDropDown;
function closeDropDown() {
	if (!document.documentElement.classList.contains(`ua-mobile`)) return;
	let btn = document.querySelector(`.newButton`);
	if (btn?.classList.contains(`showList`)) {
		btn?.classList.remove(`showList`);
	}
}

export default {
	components: { SelectExistingDocument },
	mixins: [new ItemTileFade()],
	computed: {
		...mapGetters([`isEmpty`, `existingUpload`]),
		disableAtLimit() {
			return { "ui-state-disabled": !this.canAdd };
		},
		isSignedIn() {
			return isUserSignedIn();
		},
		noFiles() {
			return { "newStart": this.isEmpty };
		},
		...mapState(`API`, [`notarizationId`]),
		...mapState([
			`acceptedExtensions`,
			`uploadStatusEnum`,
			`uploadTypeEnum`,
			`maxFileSize`,
			`uploadFileInputId`,
			`uploadDropBox`,
			`maxSelectedDocuments`,
		]),
		...mapState([`notarizationDocuments`]),
		...mapGetters([`acceptAttribute`, `canAdd`, `uploadingCount`]),
	},
	methods: {
		dragover(event) {
			event.preventDefault();
			// Add some visuals to show the user can drop its files
			if (!event.currentTarget.classList.contains(`dropHover`)) {
				event.currentTarget.classList.remove(`dropPlain`);
				event.currentTarget.classList.add(`dropHover`);
			}
		},
		dragleave(event) {
			// Clean up visuals
			event.currentTarget.classList.add(`dropPlain`);
			event.currentTarget.classList.remove(`dropHover`);
		},
		addDocumentOnClick() {
			if (!document.documentElement.classList.contains(`ua-mobile`)) return;
			let btn = $(this.$refs.addDocument);
			if (!btn.hasClass(`showList`)) {
				btn.addClass(`showList`);
			} else {
				btn.removeClass(`showList`);
			}
		},
		openShowExistingDialog() {
			this.showExistingDialog(true);
		},
		uploadFile(event) {
			// Prevent a new tab opening
			event.preventDefault();
			let urlParams = new URLSearchParams(document.location.search);
			let notarySource = urlParams.get(`notary_source`);
			let files = event.target.files || event.dataTransfer.files;
			const fileList = Array.from(files);
			let validUploads = [];
			if (fileList.length > this.maxSelectedDocuments) {
				fileList.splice(this.maxSelectedDocuments);
			}
			for (let file of fileList) {
				let upload = {
					id: nanoid(),
					file: file,
					status: this.uploadStatusEnum.UPLOADING,
					type: this.uploadTypeEnum.UPLOAD,
					message: ``,
				};				
				// Clean up visuals
				event.currentTarget.classList.add(`dropPlain`);
				event.currentTarget.classList.remove(`dropHover`);				

				const component = `File Upload`;
				const fileExtension = extension(upload.file.name);

				if (!this.acceptedExtensions.has(fileExtension)) {
					upload.status = this.uploadStatusEnum.FILE_TYPE;
					upload.message = `Unsupported file type`;
					this.submitUploadFailureEvent({ component, extra: `Invalid Format: ${fileExtension}` });
				} else if (upload.file.size > this.maxFileSize) {
					upload.status = this.uploadStatusEnum.TOO_LARGE;
					upload.message = `File size exceeded`;
					this.submitUploadFailureEvent({ component, extra: `Invalid File Size: ${upload.file.size}` });
				} else if (upload.file.size == 0) {
					upload.status = this.uploadStatusEnum.ZERO_BYTE;
					upload.message = `Empty file is invalid`;
					this.submitUploadFailureEvent({ component, extra: `Empty File` });
				} else if (!this.canAdd) {
					upload.status = this.uploadStatusEnum.ERROR;
					upload.message = `File limit reached.`;
					this.submitUploadFailureEvent({ component, extra: `File limit` });
				} else {
					upload.message = `Uploading file`;
					// Passes validation, add to valid uploads array
					validUploads.push(upload);
				}
				this.addUpload(upload);
			}
			if (validUploads.length > 0) {				
				this.ensureNotarization(notarySource).then(() => {
					//proceed with upload of all files after creating notarization id
					for (let upload of validUploads) {
						let promise = vfsUpload(upload.file, this.notarizationId);
						this.handleUploadPromise({ promise, upload });
					}
				}).catch(() => {
					for (let upload of validUploads) {
						this.updateUpload({
							id: upload.id,
							type: upload.type,
							status: this.uploadStatusEnum.ERROR,
							message: `failed`
						});
					}
				});
			}
			// Clear the input's files, browsers might try and cache this and if you navigate
			// with the back button, it will repopulate the input and fire change events
			// But also this isnt supported on older versions of internet explorer (throws error if you try), but those older browsers
			// Dont have the caching problem, so we can ignore the step for them anyways
			try {
				event.target.value = null;
			} catch (e) { }
		},
		addDocuments(items) {
			let urlParams = new URLSearchParams(document.location.search);
			let notarySource = urlParams.get(`notary_source`);
			this.ensureNotarization(notarySource).then(() => {
				for (let item of items) {
					let reusedData = this.notarizationDocuments.some(o => o.originalFileId != null && item.WebuserFileID != null && o.originalFileId == item.WebuserFileID);
					let reusedFile = this.notarizationDocuments.some(o => o.originalDataId != null && item.ItemId != null && o.originalDataId == item.ItemId);

					if (reusedData || reusedFile) {
						this.doDocumentRefresh(item.NotaryDocumentId).then(() => this.ItemTileFadeNow());
					} else {
						this.addExistingDocument(item);
					}
				}
			});
		},
		addExistingDocument(item) {
			let promise;
			let upload = {
				id: nanoid(),
				file: { name: item.Name },
				status: this.uploadStatusEnum.UPLOADING,
				message: UploadMessages.CONVERT,
			};
			if (extension(upload.file.name) === `.pdf` || item.DocumentType.toLowerCase() === `pdf`)
				upload.message = UploadMessages.ADD;
			if (item.WebuserFileID > 0) {
				upload.type = this.uploadTypeEnum.MYDOCUMENTS;
				upload.file.id = item.WebuserFileID;
				promise = myDocuments(upload.file.id, this.notarizationId);
			} else {
				upload.type = this.uploadTypeEnum.LAWDEPOT;
				upload.file.id = item.ItemId;
				promise = lawDepot(upload.file.id, this.notarizationId);
			}
			this.handleUploadPromise({ promise, upload });
			this.addUpload(upload);
		},
		...mapMutations([`showExistingDialog`, `addUpload`, `clearExistingStatus`, `openSignInDialog`, `updateUpload`]),
		...mapActions([`ensureNotarization`,`handleUploadPromise`, `submitUploadFailureEvent`]),
		...mapActions([`doDocumentRefresh`]),
		...mapActions([`loadDocuments`]),
	},
};
</script>